import { Component,VERSION, OnInit , ViewEncapsulation,ViewChild} from '@angular/core';

import { FormControl, Validators } from "@angular/forms";

import {MatTabsModule,MatTabGroup,MatTabChangeEvent} from '@angular/material/tabs';

import { MatSort } from '@angular/material/sort';

import { MatPaginator, PageEvent } from '@angular/material/paginator';

import { MatTableDataSource } from '@angular/material/table';

import { MatDatepickerModule } from '@angular/material/datepicker';

import { MatNativeDateModule } from '@angular/material/core';

import { ReceiptpreviewComponent } from '../dialogs/receiptpreview/receiptpreview.component';

import { Expense } from 'src/app/model/expense.model';

import { Category } from 'src/app/model/category.model';

import { NewExpense } from 'src/app/model/newexpense.model';

import { SubCategory } from 'src/app/model/subcategory.model';

import { SuperSubCategory } from 'src/app/model/supersubcategory.model';

import { ApiService } from 'src/app/services/api.service';

import { AlertDialog } from 'src/app/dialogs/alerts/alert-dialog.component';

import {formatDate} from '@angular/common';

import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

import { MatDialog } from '@angular/material/dialog';

import { AreaData } from '../model/area.model';

import { DateAdapter } from '@angular/material/core';

import { Role } from '../model/role';

@Component({

  selector: 'app-expenses',

  templateUrl: './expenses.component.html',

  styleUrls: ['./expenses.component.scss'],

  encapsulation: ViewEncapsulation.None

})

export class ExpensesComponent implements OnInit {

  @ViewChild(MatSort, { static: true }) sort: MatSort;

  @ViewChild(MatPaginator) paginator: MatPaginator;

  maxDate:Date

  constructor( private apiService: ApiService,public dialog: MatDialog,private sanitizer:DomSanitizer,private dateAdapter: DateAdapter<Date>) {

    this.maxDate = new Date();

    this.maxDate.setDate(this.maxDate.getDate() - 1);

    this.checkLoginType();

   }

  dataSource: MatTableDataSource<Expense>;

  ngOnInit(): void {

    this.getAllCategories();

    this.getAllAreas();

  }

  imgSrc: SafeUrl | null = null;

  display='Select File';

  displayProgressSpinner: boolean;

  categoryName:String;

  selectedCategory:number;

  selectedAddSubCategory:number;

  selectedDelCategory:number;

  selectedDelSubCategory:number;

  subCategoryName:String;

  superSubCategoryName:String;

  selectedSuperAddCategory:number;

  selectedAddSuperSubCategory:number;

  selectedSuperDelCategory:number;

  selectedDelSuperSubCategory:number;

  selectedSuperSubCategory:number;

  // New search properties
  selectedSearchOption: string = '0';
  searchValue: string = '';
  enableSearchButton: boolean = false;
  fromDate: Date = null;
  toDate: Date = null;
  allExpenses: Expense[] = [];

  displayedColumns: string[] = [

    'exp_id',

    'exp_date',

    'category',

    'sub_category',

    'super_sub_category',

    'amount',

    'remarks',

    'status',

    'receipt',

    'requestor_name',

    'requested_date',

    'area_name',

    'auditor_name',

    'approver_name',

    'approved_date',

    'action',

  ];

  selectedExpense:Expense;

  approveExpense:Expense;

  onChange(event: MatTabChangeEvent) {

    const tab = event.tab.textLabel;

    console.log(tab);

    if(tab==="View All Expenses")

     {

       this.loadAllExpenses();

      }

  }

  categories: Category[];

  areas:AreaData[];

  emprole:string;

  disableExpense:boolean;

  approverLevel:number;

  loginUser:string;

  areaCode:string;

  newExpense: NewExpense = {

    categoryId:null,

    subCategoryId:null,

    superSubCategoryId:'',

    expense_date:null,

    expense_amount:null,

    createdBy:null,

    remarks:null,

    billProof: null,

    area_code:null

  }

  subCategories:SubCategory[];

  superCategories:SubCategory[];

  superSubCategories:SuperSubCategory[];

  expenseSubCategories:SubCategory[];

  expenseSuperSubCategories:SubCategory[];

  isAuditor:boolean = false;

  isApprover:boolean = false;

  isRequester : boolean=false;

 

checkLoginType() {

  const loggedInUser = window.localStorage.getItem('loggedInUser');

  this.loginUser = loggedInUser;

  // this.apiService.getEmployeeDetailsById(loggedInUser).subscribe((data) => {

  //   this.emprole=data.employeeRole;

  //   this.areaCode = data.areaCode;

  //   if(this.emprole === 'auditor'){

  //   this.approverLevel = 1;

  //   }

  //   else if(this.emprole === 'approver'){

  //     this.approverLevel = 2;

  //   }

    

  // });



    this.apiService.getEmplyeeDetailsById(loggedInUser).subscribe((data) => {

        

         let roles = data.roles.map((role : Role)=>role.roleName);

         if(roles.includes("auditor")){

          this.approverLevel = 1;

          this.isAuditor = true;  

         } else if(roles.includes('approver')){

          this.approverLevel = 2;

          this.isApprover=true;

        }else if(roles.includes('requester')){

          this.isRequester=true;

        }





  

         

      });

}

  addCategory(){

    this.displayProgressSpinner = true;

    this.apiService.addCategory(this.categoryName).subscribe((data) => {

      this.categories=data.categories;

      this.displayProgressSpinner = false;

      this.openAlertDialog("Category Added");

    }

    ,

    (error) => {

      this.displayProgressSpinner = false;

      this.throwError();

    });

  }

  getAllCategories(){

    this.apiService.getAllCategories().subscribe((data) => {

      this.categories=data.categories;

    });

  }

  getAllAreas(){

    this.apiService.getAreaDetails().subscribe((data) => {

      this.areas=data.areas;

    });

  }

  onDelSubChange(value: any) {

    this.selectedDelCategory = value;

    this.apiService.getAllSubCategories(this.selectedDelCategory).subscribe((data) => {

      this.subCategories=data.subcategories;

    },

    (error) => {

      this.displayProgressSpinner = false;

      this.throwError();

    });



  }

  onAddCatChange(value: any){

  this.subCategoryName='';

  }

  onExpCatChange(value: any) {



  }

  onExpSubCatChange(value: any) {



  }

  deleteCategory(){

    this.displayProgressSpinner = true;

    this.apiService.deleteCategory(this.selectedCategory).subscribe((data) => {

      this.categories=data.categories;

      this.displayProgressSpinner = false;

      this.openAlertDialog("Category deleted");

    },

    (error) => {

      this.displayProgressSpinner = false;

      this.throwError();

    });

  }

  addSubCategory(){

    this.displayProgressSpinner = true;

    this.apiService.addSubCategory(this.subCategoryName,this.selectedAddSubCategory).subscribe((data) => {

      this.subCategories=data.subcategories;

      this.displayProgressSpinner = false;

      this.openAlertDialog("Sub Category added");

    },

    (error) => {

      this.displayProgressSpinner = false;

      this.throwError();

    });

  }

  deleteSubCategory(){

    this.displayProgressSpinner = true;

    this.apiService.deleteSubCategory(this.selectedDelSubCategory).subscribe((data) => {

      this.subCategories=data.subcategories;

      this.displayProgressSpinner = false;

      this.openAlertDialog("Sub Category deleted");

    }

    ,

    (error) => {

      this.displayProgressSpinner = false;

      this.throwError();

    });

  }

  addSuperSubCategory(){

    this.displayProgressSpinner = true;

    this.apiService.addSuperSubCategory(this.superSubCategoryName,this.selectedAddSuperSubCategory).subscribe((data) => {

      this.subCategories=data.subcategories;

      this.displayProgressSpinner = false;

      this.openAlertDialog("Super Sub Category added");

    },

    (error) => {

      this.displayProgressSpinner = false;

      this.throwError();

    });

  }

  deleteSuperSubCategory(){

    this.displayProgressSpinner = true;

    this.apiService.deleteSuperSubCategory(this.selectedSuperSubCategory).subscribe((data) => {

      this.superSubCategories=data.supersubcategories;

      this.displayProgressSpinner = false;

      this.openAlertDialog("Super Sub Category deleted");

    },

    (error) => {

      this.displayProgressSpinner = false;

      this.throwError();

    });

  }

  onAddSuperSubChange(value: any){

    this.selectedSuperAddCategory = value;

    this.superSubCategoryName = '';

    this.apiService.getAllSubCategories(this.selectedSuperAddCategory).subscribe((data) => {

      this.superCategories=data.subcategories;

    },

    (error) => {

      this.displayProgressSpinner = false;

      this.throwError();

    });

  }

  onDelSuperSubChange(value: any){

  this.selectedSuperDelCategory =value;

  this.selectedSuperSubCategory = null;

  this.apiService.getAllSubCategories(this.selectedSuperDelCategory).subscribe((data) => {

    this.superCategories=data.subcategories;

  },

  (error) => {

    this.displayProgressSpinner = false;

    this.throwError();

  });

  }

  loadSuperSubCat(value: any){

    this.selectedDelSuperSubCategory = value;

    this.apiService.getAllSuperSubCategories(this.selectedDelSuperSubCategory).subscribe((data) => {

      this.superSubCategories=data.supersubcategories;

    },

    (error) => {

      this.displayProgressSpinner = false;

      this.throwError();

    });

  }

  loadExpenseSubCat(value: any){

    this.apiService.getAllSubCategories(value).subscribe((data) => {

      this.expenseSubCategories=data.subcategories;

    },

    (error) => {

      this.displayProgressSpinner = false;

      this.throwError();

    });

  }

  loadExpenseSuperSubCat(value: any){

    this.apiService.getAllSuperSubCategories(value).subscribe((data) => {

      this.expenseSuperSubCategories=data.supersubcategories;

    },

    (error) => {

      this.displayProgressSpinner = false;

      this.throwError();

    });

  }

  requestExpense(){

    this.displayProgressSpinner = true;

  const formData = new FormData();

  formData.append("billProof", this.newExpense.billProof);

  formData.append("categoryId", this.newExpense.categoryId);

  formData.append("subCategoryId", this.newExpense.subCategoryId);

  formData.append("superSubCategoryId", this.newExpense.superSubCategoryId);

  formData.append("requestor", window.localStorage.getItem('loggedInUser'));

  formData.append("expense_amount", this.newExpense.expense_amount);

  formData.append("area_code",this.newExpense.area_code);

  formData.append("expense_date", this.newExpense.expense_date);

  formData.append("remarks", this.newExpense.remarks);

    this.apiService.addExpense(formData).subscribe((data) => {

      if(data.isSuccess==true){

        this.displayProgressSpinner = false;

        this.openAlertDialog("Expense Added");

      }

      else{

        this.displayProgressSpinner = false;

        this.throwError();

      }

    },

    (error) => {

      this.displayProgressSpinner = false;

      this.throwError();

      this.disableExpense = false;

    });

  }

  handleFileInputChange(event): void {

    const file: File = event.target.files[0];

    this.newExpense.billProof = file;

    this.display=file.name;

  }

  openAlertDialog(msg:String) {

    this.dialog.open(AlertDialog, {

      data: {

        icon: 'Check',

        message: msg+ ' successfully'

      }

    });

  }



  openAlertDialogAsync() {

    setTimeout(() => {

      this.dialog.open(AlertDialog, {

        data: {

          icon: 'Check',

          message: 'This Alert Dialog opened asynchronously'

        }

      });

    }, 200);

  }



  throwError() {

    throw new Error('An error has occurred while processing. Please try again..');

  }



  throwErrorAsync() {

    setTimeout(() => {

      throw new Error('An Asynchronous error has occurred');

    }, 200);

  }

  applyFilter(filterValue: string) {

    filterValue = filterValue.trim(); // Remove whitespace

    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches

    this.dataSource.filter = filterValue;

  }

  // New search functionality
  validateSearch() {
    this.enableSearchButton = this.selectedSearchOption !== '0' && this.searchValue.trim() !== '';
  }

  onDateChange() {
    this.validateSearch();
  }

  searchExpenses() {
    if (!this.allExpenses || this.allExpenses.length === 0) {
      return;
    }

    let filteredExpenses = [...this.allExpenses];

    // Apply field-specific search
    if (this.selectedSearchOption && this.searchValue.trim()) {
      const searchValue = this.searchValue.toLowerCase().trim();
      
      filteredExpenses = filteredExpenses.filter(expense => {
        const fieldValue = expense[this.selectedSearchOption];
        return fieldValue && fieldValue.toString().toLowerCase().includes(searchValue);
      });
    }

    // Apply date range filter
    if (this.fromDate || this.toDate) {
      filteredExpenses = filteredExpenses.filter(expense => {
        if (!expense.exp_date) return false;
        
        const expenseDate = new Date(expense.exp_date);
        const fromDate = this.fromDate ? new Date(this.fromDate) : null;
        const toDate = this.toDate ? new Date(this.toDate) : null;
        
        if (fromDate && expenseDate < fromDate) return false;
        if (toDate && expenseDate > toDate) return false;
        
        return true;
      });
    }

    this.dataSource.data = filteredExpenses;
  }

  clearSearch() {
    this.selectedSearchOption = '0';
    this.searchValue = '';
    this.fromDate = null;
    this.toDate = null;
    this.enableSearchButton = false;
    
    if (this.allExpenses && this.allExpenses.length > 0) {
      this.dataSource.data = this.allExpenses;
    }
  }

  loadAllExpenses(){

    this.apiService.getAllExpenseDetails().subscribe((data) => {

      this.allExpenses = data.expenses || [];
      this.dataSource = new MatTableDataSource(this.allExpenses);

      this.dataSource.paginator = this.paginator;

    this.dataSource.sort = this.sort;

    },

    (error) => {

      this.displayProgressSpinner = false;

      this.throwError();

    });

  }

  // Navigation functions for quick access
  goToFirstPage(): void {
    if (this.paginator && this.dataSource) {
      this.paginator.firstPage();
    }
  }

  goToLastPage(): void {
    if (this.paginator && this.dataSource) {
      const totalPages = Math.ceil(this.dataSource.data.length / this.paginator.pageSize);
      this.paginator.pageIndex = totalPages - 1;
      this.paginator.page.emit({
        pageIndex: this.paginator.pageIndex,
        pageSize: this.paginator.pageSize,
        length: this.dataSource.data.length
      });
    }
  }

  showMeterReading(expData: Expense): void {

    const dialogRef = this.dialog.open(ReceiptpreviewComponent, {

      width: '750px',

      data: expData,

    });



    dialogRef.afterClosed().subscribe((result) => {

    });

  }



  approve(){

    this.displayProgressSpinner = true;

    this.apiService.approveExpense(this.approverLevel,this.approveExpense.exp_id,this.loginUser).subscribe((data) => {

      

      if(data.isSuccess==true){

        this.displayProgressSpinner = false;

        this.openAlertDialog("Expense Approved");

        this.loadAllExpenses();

      }

      else{

        this.displayProgressSpinner = false;

        this.throwError();

      }

    },

    (error) => {

      this.displayProgressSpinner = false;

      this.throwError();

    }

    );

  }

  rejectExpense(){

  this.displayProgressSpinner = true;

  this.apiService.rejectExpense(this.approverLevel,this.selectedExpense.exp_id,this.loginUser).subscribe((data) => {

    

    if(data.isSuccess==true){

      this.displayProgressSpinner = false;

      this.openAlertDialog("Expense Rejected");

      this.loadAllExpenses();

    }

    else{

      this.displayProgressSpinner = false;

      this.throwError();

    }

  },

  (error) => {

    this.displayProgressSpinner = false;

    this.throwError();

  }

  );

}

}